import { IconButton } from "@material-ui/core"
import { useDispatch } from "react-redux"
import {declinarFacturaAction, obtenerFacturasPendientesAction } from "../../../ducks/facturacionRecienteDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { DialogMessage } from "../../../global/DialogMessage"

const ButtonDeclinarFactura = (props) => {
    const { IdFactura } = props
    const dispatch = useDispatch()
    const onDeclinarSolicitud = () => {
        DialogMessage.fire({
            title: '¿Estas seguro de declinar esta solicitud de rembolso?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(declinarFacturaAction({ IdFactura: IdFactura })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                        });
                        return null
                    }
                    if (Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response?.Message,
                        });
                        return null
                    }
                    dispatch(obtenerFacturasPendientesAction())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
      
    }
    return (
        <IconButton aria-label="Declinar solicitud" onClick={onDeclinarSolicitud}>
            <HighlightOffIcon color="error" />
        </IconButton>
    )
}
export default ButtonDeclinarFactura